export const dummyRequest = ({ onSuccess }) => {
  onSuccess({ code: 200 }, null);
};
